import React, { useMemo } from 'react';
import { useTable, usePagination } from 'react-table';
import '../componentscss/NetworkTable.css';

const NetworksTable = ({ projects, handleOpenModal }) => {
  const data = useMemo(() => projects, [projects]);

  const columns = useMemo(
    () => [
      {
        Header: 'Project Card',
        accessor: 'card',
        Cell: ({ row }) => (
          <div className="gradient-border-box">
            <div className="group content min-h-32 flex flex-row justify-between items-center shadow-lg ">
                <img src={row.original.logo} alt={row.original.name} className="w-12 h-12 md:w-16 md:h-16" />
                <div className='w-30 md:w-36'>
                    <h2 className="network-name text-white text-lg font-bold">{row.original.name}</h2>
                    <p className="network-value flex flex-row  text-white text-sm">
                        <p className="network-apr mr-2" >APR</p> 
                        {row.original.apr ? Number(row.original.apr).toFixed(2) + " %" : "No data"}
                    </p>
                </div>
                <button onClick={() => handleOpenModal(row)} className="network-button text-white bg-[#010622] py-2 px-4 rounded transition duration-300 ease-in-out hover:bg-custom-orange hover:text-white">
                    MORE
                </button>
            </div>
        </div>
        ),
      },
    ],
    [handleOpenModal]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page, 
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 12 }, // Set initial page size
    },
    usePagination // Add usePagination hook
  );

  // Calculate the number of empty rows needed
  const emptyRows = pageSize - page.length;

  return (
    <div className=" w-[80vw] p-5">
      <div {...getTableProps()} className="w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {page.map((row) => {
            prepareRow(row);
            return (
              <div {...row.getRowProps()} className="w-full">
                {row.cells.map((cell) => (
                  <div {...cell.getCellProps()} className="w-full ">
                    {cell.render('Cell')}
                  </div>
                ))}
              </div>
            );
          })}

          {/* Render empty rows to maintain consistent height */}
          {emptyRows > 0 && Array(emptyRows).fill(null).map((_, index) => (
            <div key={`empty-row-${index}`} className="empty-row w-full h-32"></div>
          ))}
        </div>
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-end mt-4 space-x-2">
        <button
          className="text-white bg-[#e94560] hover:bg-[#c73248] py-2 px-4 rounded disabled:opacity-50"
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          {'<'}
        </button>
        <span className="text-white py-2 page-text">
          {' '}
          <strong>
            {pageIndex + 1}
          </strong>
          {' '}
          <span>
          of
          </span>
          {' '}
          <strong>
            {pageOptions.length}
          </strong>
          {' '}
        </span>
        <button
          className="text-white bg-[#e94560] hover:bg-[#c73248] py-2 px-4 rounded disabled:opacity-50"
          onClick={() => nextPage()}
          disabled={!canNextPage}
        >
          {'>'}
        </button>
      </div>
    </div>
  );
};

export default NetworksTable;
